exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.error_message[data-v-40e17dcf] {\n  font-size: 85%;\n  padding-top: 6px;\n  margin-bottom: 0;\n}\n", "", {"version":3,"sources":["/Users/fine/code/oped/laravel/resources/assets/js/vue/component/modal/personal.vue"],"names":[],"mappings":";AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;CAAE","file":"personal.vue","sourcesContent":[".error_message {\n  font-size: 85%;\n  padding-top: 6px;\n  margin-bottom: 0; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40e17dcf","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/vue/component/modal/personal.vue
// module id = ./node_modules/css-loader/index.js?sourceMap!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-40e17dcf","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/vue/component/modal/personal.vue
// module chunks = 0